import { render, staticRenderFns } from "./chat-notification.vue?vue&type=template&id=0419cbf7&scoped=true"
import script from "./chat-notification.vue?vue&type=script&lang=js"
export * from "./chat-notification.vue?vue&type=script&lang=js"
import style0 from "./chat-notification.vue?vue&type=style&index=0&id=0419cbf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0419cbf7",
  null
  
)

export default component.exports